<template>
    <div id="ChangeMobile">

       <div class="g-right-middle width800 g-ypxx">
       	<p>
       		<span class='ypxx-left'>手机号</span>
       		<span class="ypxx-right">
				<input type="text"  v-model="mobile" placeholder="请输入您要修改的手机号">
			</span>
			<div class="clearfix"></div>
		</p>
		<p>
			<span class='ypxx-left'>验证码</span>
			<span class="ypxx-right">
				<input v-model="code"  style="width: 250px;" type="text" placeholder="请输入手机验证码" />
				<input @click="send(mobile)" class="yzm-btn" type="button" value="发送验证码">
			</span>
			<div class="clearfix"></div>
		</p>

			<center><input @click="updateInfo" type="button" class="g-btn" value="确认提交"></center>
		</div>
    </div>
</template>
<script>
	import Axios from 'axios'
	import storage from '../../../storage/storage.js'
	export default{
		data(){
			return{
				//picture:'',
				mobile:'',
				code:''

			}
		},
		methods:{
			send(mobile) {
				var api = "http://api.yopoo.cn/api/v1/code?mobile=" + mobile;
				if (mobile == "") {
					this.$message({
						message: '请输入手机号',
						type: 'warning',
						center:true

					});
				} else {
					this.$http.get(api).then(
						response => {

							this.$message({
								message: res.data.msg,
								type: 'success',
								center:true
							});
						},
						err => {
							console.log(err);
						}
					);
				}
			},
			updateInfo(){
				var api='http://api.yopoo.cn/api/centre//updateMobile'
				let updateinfo={
					mobile:this.mobile,
					code:this.code
				}
				Axios.post(api,updateinfo).then((res)=>{


					if(res.data.code=='200'){
						this.$message({
							message: res.data.msg,
							type: 'success',
							center:true
						});
						storage.clear()
						setTimeout(() => {
								this.$router.push(

									{path:'/login',
									} //据说是验证是否需要权限的东西，待验证
								)   //登录后跳转页面
							}, 500);
						}

					else{
						this.$message({
							message: res.data.msg,
							type: 'error',
							center:true

						});
					}
				}).catch((res)=>{

				})
			}
		}
	}
</script>
<style>
	.yzm-btn{
		width: 94px;
height: 34px;
background: #f4f4f4;
border-radius: 5px;
border: 1px solid #d9d9d9;
color: #555;
cursor: pointer;

	}
	.yzm-btn:hover{
		background: #e3e3e3;
	}
</style>



// WEBPACK FOOTER //
// src/components/group_admin/change/G_ChangeMobile.vue